import React from 'react';
import { useConnect } from '@lore/query-connect';
import REQUIRED_FIELDS from '../../events/REQUIRED_FIELDS';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../MetricLoader';
import moment from 'moment-timezone';
import ComparisonMetric from '../ComparisonMetric';

export default function AssociatedWithEvent(props) {
  const { network, schoolStart, schoolEnd, titleOnly } = props;

  const previousSchoolStart = moment(schoolStart).subtract(1, 'year').toISOString();

  const previousSchools = useConnect('site.find', {
    where: {
      eager: {
        $where: {
          events: {
            $where: {
              $and: REQUIRED_FIELDS.$and,
              // 'creator.isEducator': true,
              networkId: network?.id,
              createdAt: {
                $lte: schoolStart,
                // $gte: titleOnly ? undefined : previousSchoolStart
              }
            },
            $having: {
              count: {
                $gte: 1
              }
            }
          }
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  const allSchools = useConnect('site.find', {
    where: {
      eager: {
        $where: {
          events: {
            $where: {
              $and: REQUIRED_FIELDS.$and,
              // 'creator.isEducator': true,
              networkId: network?.id,
              createdAt: {
                $lte: schoolEnd,
                // $gte: schoolStart
              }
            },
            $having: {
              count: {
                $gte: 1
              }
            }
          }
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  if (
    previousSchools.state === PayloadStates.FETCHING ||
    allSchools.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name="Engaged with Event"
      />
    );
  }

  return (
    <ComparisonMetric
      name="Engaged with Event"
      value={allSchools.meta.totalCount}
      previousValue={previousSchools.meta.totalCount}
      titleOnly={titleOnly}
    />
  );
}
